import { connectToStores } from 'fluxible-addons-react';
import PropTypes from 'prop-types';
import React from 'react';
import BriefStore from 'contest/stores/brief-store';

import TranslationMenu from 'contest/components/translation-menu';
import briefTranslateAction from 'contest/actions/brief-translate';

class TranslationMenuWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.changeLanguage = this.changeLanguage.bind(this);
    }

    render() {
        return <TranslationMenu {...this.props} onChangeLanguage={this.changeLanguage} />;
    }

    changeLanguage(translateTo) {
        this.context.executeAction(briefTranslateAction, {
            url: this.props.translationEndpointUrl,
            translateTo: translateTo,
        });
    }
}

TranslationMenuWrapper.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

TranslationMenuWrapper.propTypes = {
    translationEndpointUrl: PropTypes.string.isRequired,
};

const ConnectedTranslationMenu = connectToStores(
    TranslationMenuWrapper,
    [BriefStore],
    (context, props) => {
        const store = context.getStore(BriefStore);
        return {
            languages: store.languages,
            selectedLanguageKey: store.selectedLanguageKey,
            translationInProgress: store.translationInProgress,
            translationFailed: store.translationFailed,
            translationEndpointUrl: store.translationUrl,
        };
    }
);

export default ConnectedTranslationMenu;



// WEBPACK FOOTER //
// ./src/web/js/contest/components/connected/connected-translation-menu.jsx